import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let VCheckBox = class VCheckBox extends Vue {
    constructor() {
        super(...arguments);
        this.isChecked = false;
    }
    updated() {
        this.$nextTick(() => {
            this.isChecked = this.checkControl;
        });
    }
    check() {
        if (this.disabled)
            return;
        this.isChecked = !this.isChecked;
        this.$emit("check", this.index, this.isChecked, this.id);
        this.$bus.$emit("get-check-box", this.index, this.isChecked);
    }
};
tslib_1.__decorate([
    Prop({ type: Number, required: true })
], VCheckBox.prototype, "index", void 0);
tslib_1.__decorate([
    Prop({ type: Array, default: () => [] })
], VCheckBox.prototype, "status", void 0);
tslib_1.__decorate([
    Prop({ type: [String, Object], default: () => { } })
], VCheckBox.prototype, "id", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VCheckBox.prototype, "checkControl", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VCheckBox.prototype, "isActive", void 0);
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], VCheckBox.prototype, "disabled", void 0);
VCheckBox = tslib_1.__decorate([
    Component({
        name: 'VCheckBox',
    })
], VCheckBox);
export default VCheckBox;
